import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Reveal, ChapterHead } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Blog = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/entries`)
      .then((r) => setPosts(r.data.filter((e) => ["BLOG", "THOUGHT"].includes(e.type)).reverse()))
      .catch(() => setPosts([]));
  }, []);

  return (
    <section id="blog" className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 max-w-7xl mx-auto" data-testid="blog-section">
      <ChapterHead index="CHAPTER 08" title="THE JOURNAL" />

      {posts === null && (
        <p className="font-meta text-xs tracking-[0.3em] text-blue-300/50" data-testid="blog-loading">LOADING…</p>
      )}

      {posts !== null && posts.length === 0 && (
        <Reveal>
          <div className="border border-blue-100/15 p-8 sm:p-14" data-testid="blog-empty">
            <p className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight">
              Thoughts and opinions land here.
            </p>
            <p className="text-sm sm:text-base font-light text-blue-100/60 mt-3 max-w-xl">
              Whenever something crosses Jeremiah's mind — an observation, an argument, a question —
              it gets written and published here, dated, straight from the source.
            </p>
          </div>
        </Reveal>
      )}

      {posts !== null && posts.length > 0 && (
        <div className="border-t border-blue-100/10" data-testid="blog-list">
          {posts.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.04}>
              <Link
                to={`/archive/${p.slug}`}
                data-testid={`blog-entry-${p.slug}`}
                className="group grid grid-cols-12 gap-3 sm:gap-6 items-baseline border-b border-blue-100/10 py-6 sm:py-8 px-2 sm:px-4 -mx-2 sm:-mx-4 hover:bg-[#4F7CFF] transition-colors duration-300"
              >
                <span className="col-span-3 sm:col-span-2 font-meta text-[10px] sm:text-xs tracking-[0.2em] text-blue-300/50 group-hover:text-white/70 transition-colors duration-300">
                  {p.date_display}
                </span>
                <span className="col-span-9 sm:col-span-6 font-display text-xl sm:text-2xl font-bold uppercase tracking-tight leading-tight">
                  {p.title}
                </span>
                <span className="hidden sm:block sm:col-span-3 text-sm font-light text-blue-100/50 group-hover:text-white/80 transition-colors duration-300 line-clamp-2">
                  {p.text.replace(/\n+/g, " ").slice(0, 90)}…
                </span>
                <span className="hidden sm:flex sm:col-span-1 justify-end font-display text-2xl group-hover:translate-x-2 transition-transform duration-300">
                  →
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      )}
    </section>
  );
};
